import React, { useEffect, useState } from "react";

import { Header } from "components/Header";
import ExportReportModal from "components/Modals/ExportReportModal";
import { SearchBar } from "components/SearchBar";
import { IOccurrence } from "interfaces/Occurrence";
import { IGetOccurrencesResponse } from "services/OccurrenceService";
import * as S from "./styles";

import { DashboardTemplate } from "templates/DashboardTemplate";

import { StepRegisterOccurrence } from "components/Modals/StepRegister/StepRegisterOccurrence";
import { IUser } from "interfaces/User";
import { useLocation } from "react-router-dom";
import { CheckAlert } from "utils/checkAlert";
// import AnexModal from "components/Modals/EstablishmentAnexModal.tsx";
import { CommentsModal } from "components/Modals/CommentsModal";
import { PicturesReportModal } from "components/Modals/PicturesReportModal";
import { StepReportModal } from "components/Modals/StepReportModal";
import { useReport } from "contexts/ReportContext";

import { Button } from "components/Button";
import { MonitoringCard } from "components/Cards/MonitoringCard";
import { MonitoringCardSkeleton } from "components/Cards/MonitoringCard/components";
import { FilterTabBar } from "components/FilterTabBar";
import { AlertModal } from "components/Modals/AlertModal";
import { ScannerPin } from "components/ScannerPin";
import { EmptyState } from "components/display/EmptyState";
import { useDataList } from "hooks/useDataList";
import { socket } from "hooks/useSocket";
import { IReport } from "interfaces/Report";
import { useQueryClient } from "react-query";
import {
  handleOccurrenceCancelSubmit,
  handleOccurrenceDeleteSubmit,
} from "services/handles/OccurrenceHandles";

function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}
type PriorizedCards = {
  id: string;
};

type Tabs =
  | "all"
  | "onGoing"
  | "withoutPr"
  | "waitingValidation"
  | "manualOccurrence"
  | "onCancel";

export function Monitoring() {
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState<
    | "andamento"
    | "aprovacao"
    | "aguardando"
    | "concluido"
    | "aguardando_cancelamento"
    | undefined
  >();
  const [tab, setTab] = useState<Tabs>("all");
  const [isManualFilter, setIsManualFilter] = useState<boolean>(false);
  const [registerModal, setRegisterModal] = useState(false);
  const [activationModal, setActivationModal] = useState(false);
  const [reportModal, setReportModal] = useState(false);
  const [exportModal, setExportModal] = useState(false);
  const [picturesModal, setPicturesModal] = useState(false);
  const [commentModal, setCommentModal] = useState(false);
  const [storageUser, setStorageUser] = useState<IUser>();
  const [selectedReport, setSelectedReport] = useState<IReport | null>(null);
  const [occurrence, setOccurrence] = useState<IOccurrence>();
  const [priorizedCards, setPriorizedCards] = useState<PriorizedCards[]>([]);
  const { retrieveReport, report, resetReport } = useReport();
  const [isFetchingCancel, setIsFetchingCancel] = useState<boolean>(false);
  const [filterByAttendant, setFilterByAttendant] = useState<boolean>(false);
  const [page, setPage] = useState<number>(1);

  const baseSearch = {
    status,
    active: true,
    attendant: {
      // o id esta sendo enviado como fakeId pq o back-end vai substituir essa string com um id valido de attendant,
      // isso foi feito pra nao precisar mandar de formas diferentes nessa pagina e no monitoring
      id: filterByAttendant ? "fakeId" : undefined,
    },
  };

  const manualBaseSearch = { ...baseSearch, isManual: true };

  const getBaseSearch = () => (isManualFilter ? manualBaseSearch : baseSearch);

  const queryClient = useQueryClient();

  const { data, isLoading } = useDataList<IOccurrence, IGetOccurrencesResponse>(
    {
      queryKey: "listAllMonitorOccurrences",
      route: "occurrences",
      filter: {
        page: page,
        relations: {
          report: {
            policeman: {
              user: true,
            },
          },
        },
        params: [
          search
            ? { protocol: Number(search), ...getBaseSearch() }
            : { ...getBaseSearch() },
        ],
        order: {
          createdAt: "DESC",
        },
        nots: [{ key: "status", value: "concluido" }],
      },
      options: {
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        refetchInterval: 30000,
      },
    }
  );

  useEffect(() => {
    const user = localStorage.getItem("user");
    if (user) {
      setStorageUser(JSON.parse(user));
    }
    CheckAlert();
  }, []);

  useEffect(() => {
    socket.on(`monitoring-refresh`, (flag: string) => {
      console.log("socket hein");
      flag && queryClient.invalidateQueries(["listAllMonitorOccurrences"]);
    });
  }, []);

  useEffect(() => {
    const pinnedCardsLocalStorage = JSON.parse(
      localStorage.getItem("pinned") as string
    );

    if (pinnedCardsLocalStorage) {
      setPriorizedCards(pinnedCardsLocalStorage as PriorizedCards[]);
    }
  }, []);

  function getPriorizedCards(isFavorite: boolean, occurrenceId: string) {
    if (!priorizedCards.map((item) => item?.id).includes(occurrenceId)) {
      setPriorizedCards((prevState) => [...prevState, { id: occurrenceId }]);
    } else {
      setPriorizedCards((prevState) =>
        prevState.filter((priorizedCard) => priorizedCard.id !== occurrenceId)
      );
    }
  }

  return (
    <S.Container>
      <DashboardTemplate
        containerClass="wrapper"
        page={page}
        setPage={setPage}
        total={data?.item.monitor}
      >
        <Header title={"Monitoramento"} />

        <FilterTabBar
          activeOptionId={tab}
          filterOptions={[
            {
              label: `Todas (${data?.item.monitor ?? 0})`,
              value: "all",
              onClick: () => {
                setStatus(undefined);
                setTab("all");

                if (isManualFilter) {
                  setIsManualFilter(false);
                }
              },
            },
            {
              label: `Sem pronta-resposta! (${
                data?.item.withoutPoliceman ?? 0
              })`,
              value: "withoutPr",
              onClick: () => {
                setStatus("aguardando");
                setTab("withoutPr");

                if (isManualFilter) {
                  setIsManualFilter(false);
                }
              },
            },
            {
              label: `Em andamento (${data?.item.progress ?? 0})`,
              value: "onGoing",
              onClick: () => {
                setStatus("andamento");
                setTab("onGoing");

                if (isManualFilter) {
                  setIsManualFilter(false);
                }
              },
            },
            {
              label: `Ocorrências manuais (${data?.item.manual ?? 0})`,
              value: "manualOccurrence",
              onClick: () => {
                setStatus(undefined);
                setTab("manualOccurrence");
                setIsManualFilter(true);
              },
            },
            {
              label: `Aguardando atendente validar (${
                data?.item.waiting ?? 0
              })`,
              value: "waitingValidation",
              onClick: () => {
                setStatus("aprovacao");
                setTab("waitingValidation");

                if (isManualFilter) {
                  setIsManualFilter(false);
                }
              },
            },
            {
              label: "Em cancelamento",
              value: "onCancel",
              onClick: () => {
                setStatus("aguardando_cancelamento");
                setTab("onCancel");
              },
            },
          ]}
        />

        <S.SearchBarContainer>
          <SearchBar
            type="text"
            name="filter"
            id="filter"
            placeholder="Procure por número de protocolo..."
            buttonText="Cadastrar ocorrência"
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setSearch(event.target.value);
            }}
            required={false}
            haveExport={storageUser?.role.name === "financial"}
            onSaveClick={() => {
              setExportModal(true);
            }}
            isOccurrence
            onClick={() => {
              setRegisterModal(true);
            }}
          />
          <Button
            title={
              filterByAttendant ? "Minhas ocorrencias" : "Todas ocorrencias"
            }
            type="button"
            onClick={() => setFilterByAttendant((prev) => !prev)}
          />
        </S.SearchBarContainer>

        <S.CardsContainer>
          {isLoading && (
            <div>
              <MonitoringCardSkeleton />
              <MonitoringCardSkeleton />
              <MonitoringCardSkeleton />
            </div>
          )}

          {!isLoading && !data?.item.occurrences.length && !status && (
            <S.EmptyContainer>
              <ScannerPin />

              <p>Tudo certo</p>
              <span>Nenhum monitoramento sendo realizado no momento</span>
            </S.EmptyContainer>
          )}

          {!isLoading && !data?.item.occurrences.length && status && (
            <EmptyState title="Nenhum monitoramento encontrado no filtro selecionado" />
          )}

          {!isLoading &&
            data &&
            data?.item.occurrences.length > 0 &&
            data?.item.occurrences
              .sort((priorizedCardsId) =>
                priorizedCards.map(({ id }) => id).includes(priorizedCardsId.id)
                  ? -1
                  : 1
              )
              .map((occurrence) => {
                return (
                  <MonitoringCard
                    isFavorite={Boolean(
                      priorizedCards.find(({ id }) => id === occurrence.id)
                    )}
                    key={occurrence.id}
                    occurrence={occurrence}
                    attachmentsClick={(report?: IReport) => {
                      if (report) {
                        setSelectedReport(report);
                      }
                      retrieveReport(occurrence);
                      setOccurrence(occurrence);
                      setPicturesModal(true);
                    }}
                    reportClick={() => {
                      setOccurrence(occurrence);
                      retrieveReport(occurrence);
                      setPicturesModal(true);
                    }}
                    commentsClick={() => {
                      setOccurrence(occurrence);
                      retrieveReport(occurrence);
                      setCommentModal(true);
                    }}
                    cancelClick={() => {
                      setOccurrence(occurrence);
                      retrieveReport(occurrence);
                      setActivationModal(true);
                    }}
                    priorizedCard={getPriorizedCards}
                  />
                );
              })}
        </S.CardsContainer>

        {report && reportModal && occurrence && (
          <StepReportModal
            opened={reportModal}
            occurrenceData={occurrence}
            setOpened={() => {
              setOccurrence(undefined);
              resetReport();
              setReportModal(false);
            }}
          />
        )}

        {report && picturesModal && (
          <>
            <PicturesReportModal
              occurrence={occurrence}
              modalIsOpen={picturesModal}
              setSelectedReport={setSelectedReport}
              selectedReport={selectedReport}
              setIsOpen={() => {
                setSelectedReport(null);
                setOccurrence(undefined);
                resetReport();
                setPicturesModal(false);
              }}
            />
          </>
        )}
        {occurrence && commentModal && (
          <CommentsModal
            modalIsOpen={commentModal}
            setIsOpen={() => {
              setOccurrence(undefined);
              resetReport();
              setCommentModal(false);
            }}
            occurrenceId={occurrence.id}
          />
        )}

        <AlertModal
          isOpen={activationModal}
          onRequestClose={() => setActivationModal(false)}
          title="Deseja cancelar a ocorrência?"
          text={`Ao prosseguir, a ocorrência será cancelada e irá sumir da 
          tela de monitoramento. Se um pronta-resposta estiver operando ele 
          será informado e o valor de saída dele será registrado. 
          Deseja continuar?`}
          confirmButtonText="Continuar"
          isConfirmFetching={isFetchingCancel}
          confirmButtonClick={() => {
            setIsFetchingCancel(true);

            if (
              occurrence &&
              occurrence.report &&
              occurrence?.report.length > 0
            ) {
              handleOccurrenceCancelSubmit({
                occurrence,
                reportId: occurrence.report[0].id,
              });
              setIsFetchingCancel(false);
              setActivationModal(false);
              return;
            }

            return handleOccurrenceDeleteSubmit({
              occurrence,
            });
          }}
        />

        {/* <ActivationModal
          title={`Deseja cancelar a ocorrência`}
          content="Uma ocorrência cancelada não aparecerá na listagem."
          modalIsOpen={activationModal}
          setIsOpen={setActivationModal}
          buttonText="Sim, cancelar"
          onClick={() => {
            if (occurrence && occurrence.report && occurrence?.report.length > 0) {
              return handleOccurrenceCancelSubmit({
                occurrence
              })
            }

            return handleOccurrenceDeleteSubmit({
              occurrence,
            });
          }}
        /> */}
        <ExportReportModal
          modalIsOpen={exportModal}
          setIsOpen={setExportModal}
        />

        {registerModal && (
          <StepRegisterOccurrence
            opened={registerModal}
            setOpened={() => {
              setOccurrence(undefined);
              resetReport();
              setRegisterModal(false);
            }}
            occurrenceData={occurrence}
          />
        )}
      </DashboardTemplate>
    </S.Container>
  );
}
